import { Component, OnInit } from '@angular/core';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { SlWapiService } from '../../model/api-services/sl-wapi.service';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';

@Component({
    selector: 'app-logout',
    template: '',
    styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

    constructor(private messager: ModalMessagerService, private slWapi: SlWapiService, private router: Router, private env: EnvService) {
        this.slWapi.Logout().then((result) => {
            this.messager.Notify('You have been logged out');
            const path: string = this.env.GetRelPath('/');
            this.router.navigateByUrl(path);
        }).catch(() => {
            const path: string = this.env.GetRelPath('/');
            this.router.navigateByUrl(path);
        });
    }

    ngOnInit() {
    }

}
